import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddCoursePopup from "./AddCoursePopup";


interface CoursesEmptyPageProps {
  onCoursesCreated?: (newCourses: any) => void;
}


export default function CoursesEmptyPage({
  onCoursesCreated,
}: CoursesEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Courses"
      colorKey="interactions"
      AddPopupComponent={AddCoursePopup}
      onEntityCreated={onCoursesCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Course",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Course",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Log Course Attendance",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Course History",
          direction: "down",
        },
      ]}
    />
  );
}
